import { createFileRoute } from '@tanstack/react-router'
import { PriceListEditor } from './-PriceListEditor'

export const Route = createFileRoute('/packaging/price-lists/$id')({
  component: PriceListDetailPage,
})

function PriceListDetailPage() {
  const { id } = Route.useParams()
  return <PriceListEditor id={id} />
}
